/**
 * Labstep
 *
 * @module grid/NewIndex/components/ToolPanel/SystemFields
 * @desc List of system fields columns to add to the grid
 */

import { ICONS } from 'labstep-web/constants/icons';
import { SectionHeader } from 'labstep-web/core/Header';
import { NEW_INDEX_COL_DEFS } from 'labstep-web/grid/NewIndex/coldefs';
import type { NewIndexColDef } from 'labstep-web/grid/NewIndex/coldefs/types';
import { ToolPanelState } from 'labstep-web/grid/NewIndex/components/ToolPanel';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/NewIndex/components/ToolPanel/ListItem';
import { GridToolBarService } from 'labstep-web/grid/services/grid-toolbar.service';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { GridNewIndexToolPanelSystemFieldsProps } from './types';

export const GridNewIndexToolPanelSystemFields: React.FC<
  GridNewIndexToolPanelSystemFieldsProps
> = ({
  colIds,
  searchQuery,
  gridNewIndexService,
  entityView,
  premiumFeatures,
  setToolPanelState,
}) => (
  <>
    {GridToolBarService.showListSection(
      Object.values(NEW_INDEX_COL_DEFS[entityView.entity_name])
        .filter((colDef) => !colDef.pinned)
        .map((colDef) => colDef.headerName || ''),
      searchQuery,
    ) && <SectionHeader label="System fields" />}
    {Object.values(NEW_INDEX_COL_DEFS[entityView.entity_name])
      .filter((colDef) => !colDef.pinned)
      .filter(
        (colDef) =>
          entityView.context !== 'resource_show' ||
          colDef.colId !== 'resource',
      )
      .filter((colDef) => {
        if (
          entityView.entity_name !== ExperimentWorkflow.entityName
        ) {
          return true;
        }
        if (!premiumFeatures.signature_workflow) {
          return (
            colDef.colId !== 'entity_state' &&
            colDef.colId !== 'entity_state_updated'
          );
        }
        return colDef.colId !== 'entity_users';
      })
      .map((colDef: NewIndexColDef) => {
        if (
          !GridToolBarService.showListItem(
            colDef.headerName || '',
            searchQuery,
          )
        ) {
          return null;
        }
        return (
          <EntityDataGridToolPanelListItem
            icon={colDef.headerComponentParams?.icon || 'database'}
            actionIcon="eye"
            text={colDef.headerName || ''}
            onClick={() => {
              gridNewIndexService.addColumnDef(colDef);
            }}
            disabled={colIds.includes(colDef.colId || '')}
          />
        );
      })}
    {premiumFeatures.signature_workflow && (
      <EntityDataGridToolPanelListItem
        icon={ICONS.user.secondary}
        actionIcon="arrow right"
        text={'Collaborators'}
        onClick={() => {
          setToolPanelState(ToolPanelState.entity_user_roles);
        }}
      />
    )}
  </>
);
